import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import './TipIndicator.scss';
import {TaskType} from '../../../constants/dataEnum';

// const TipIndicatorBar = styled.div`
//   background-color: #1aff75;
//   height: ${(props) => (props.percentage ? `${props.percentage}%` : '0%')};
//   width: 15px;
//   position: absolute;
//   bottom: 0px;
// `;

// // https://gist.github.com/vindia/3340088
// const TipIndicatorBubble = styled.div`
//   background-color: #0060ff;
//   width: ${(props) => (props.percentage ? `${props.percentage}%` : '0%')};
//   height: ${(props) => (props.percentage ? `${props.percentage}%` : '0%')};
//   -webkit-border-top-left-radius: 0;
//   -webkit-border-top-right-radius: 150px;
//   -webkit-border-bottom-right-radius: 120px;
//   -webkit-border-bottom-left-radius: 150px;
//   -webkit-transform: rotate(45deg) translate(15%, 15%);
// `;

function TipIndicator({taskAspirateAirGapVolume, bubblePercentage, maxCapacity, minCapacity, highVolume}) {
  const getPercentages = (volume, nextVolume) => {
    let percentage = 0;
    if (nextVolume) {
      percentage = ((parseFloat(volume) + parseFloat(nextVolume)) / maxCapacity) * 100;
    } else {
      percentage = (parseFloat(volume) / maxCapacity) * 100;
    }
    return percentage > 0 ? percentage : 0;
  };

  const getAspirateHeightVisual = () => {
    const heightVisual = [];
    let previousTaskVolume = 0;

    for (let i = taskAspirateAirGapVolume.length - 1; i >= 0; i -= 1) {
      const task = taskAspirateAirGapVolume[i];
      const taskVolume = parseFloat(task.volume);
      if (task.type === TaskType.DISPENSE) {
        previousTaskVolume += taskVolume;
      } else {
        let className = 'content';

        const heightPercentage = getPercentages(taskVolume, previousTaskVolume);
        previousTaskVolume += taskVolume;

        if (task.type === TaskType.AIR_GAP) {
          className = 'content-airGap';
        }

        if (highVolume) {
          className += ' high-volume';
        }
        heightVisual.push(
          <div
            className={className}
            style={{height: `${heightPercentage}%`, zIndex: `-${taskAspirateAirGapVolume.length - i}`}}
          />,
        );
      }
    }
    return heightVisual;
  };

  return (
    <div className="tip-indicator-container">
      <div className="tip-indicator">
        <div id="tip-indicator-bar" className={highVolume ? 'high-volume' : ''}>
          {taskAspirateAirGapVolume && getAspirateHeightVisual()}
        </div>
        <div id="tip-indicator-bubble">
          <div
            className="content"
            style={{
              height: `${bubblePercentage ? `${bubblePercentage}%` : '0%'}`,
              width: `${bubblePercentage ? `${bubblePercentage}%` : '0%'}`,
            }}
          />
        </div>
      </div>
      <div>
        <img src="./svg/protocol-editor/ruler.svg" alt="Ruler" style={highVolume ? {height: 100} : {}} />
      </div>
      <div className="tip-indicator-marker">
        <span className={`tip-indicator-marker-max ${highVolume ? 'high-volume' : ''}`}>{maxCapacity}</span>
        <span className={`tip-indicator-marker-mid ${highVolume ? 'high-volume' : ''}`}>
          {parseInt((maxCapacity - minCapacity) / 2, 10)}
        </span>
        <span className={`tip-indicator-marker-min ${highVolume ? 'high-volume' : ''}`}>{minCapacity}</span>
      </div>
    </div>
  );
}

TipIndicator.propTypes = {
  taskAspirateAirGapVolume: PropTypes.any.isRequired,
  bubblePercentage: PropTypes.number,
  maxCapacity: PropTypes.number,
  minCapacity: PropTypes.number,
  highVolume: PropTypes.bool,
};

TipIndicator.defaultProps = {
  bubblePercentage: 50,
  maxCapacity: 13,
  minCapacity: 0,
  highVolume: false,
};

export default TipIndicator;
